import React, {useState, useEffect } from 'react';
import { Container, Row, Col,Button } from 'react-bootstrap';
import {useLocation,Link, useNavigate} from 'react-router-dom';
import Labels from '../../components/translations/translation.json'
import { SERVER } from '../../constants/networkUrls';

import Header from '../../layouts/header';

import './submittedPage.css';
import Footer from '../../layouts/footer/footer';
import clearStorage from '../logout/fmsLogout'


function SubmittedPage(props) {
    const location = useLocation();
    const navigate = useNavigate();

    const incidentNumber = location.state?.incidentNumber ?? "";
    const validUser = location.state?.validUser ?? "";
    const isDuplicate = location.state?.isDuplicateIncident ?? "";
    const comment = location.state?.comment ?? "";
    const isNMBSEmployee = location.state?.isNMBSEmployee ?? false;
    const isPrivate = location.state?.isPrivate ?? false;
    const isFurnitureIncident = location.state?.isFurnitureIncident ?? false;
    const isSafetySecurity = location.state?.isSafetySecurity ?? false;
    const isTVMIncident = location.state?.isTVMIncident ?? false;
    console.log("incidentNumber",incidentNumber);

    const dropDownLangCode = localStorage.getItem("languagePref");
    console.log("dropDownLangCode in submittedpage.js : ",location.state && location.state.languageCode);

    const [langCode, setlangCode] = useState(location.state && location.state.languageCode);

    document.title = isPrivate ? "FixMyOffice - Incident" : "FixMyStation - Incident"

    console.log("langCodeFromfirstPage out of useEffect in space.js : ",langCode);


   

    useEffect(()=>{
        clearStorage();
    },[])
    

    const handleEvent = (event) => {
        navigate("/",{state:{thankyou:true}})
      };
    
      useEffect(() => {
        window.addEventListener("popstate", handleEvent);
        return () => window.removeEventListener("popstate", handleEvent);
      },[]);

      const goToNMBSWebsite = () => {
        window.location.href = `https://www.belgiantrain.be/${langCode.toLowerCase()}`;
    }
   
 
    const handledropdown = async (e) => {
        setlangCode(e.target.value);
		console.log("langCode in handleDropdown in submittedPage.js : ",langCode);
	}

    const returnValidUsersSummaryMessage = () =>{
        return (
            <Container fluid className="content-container">
                        <Row>
                            <Col lg={12} md={12} sm={12} xs={12} xxs={12} className="col-conetent">
                            <span className='submitted-text'>{isPrivate ? Labels[langCode].INCIDENT_VALIDUSER_PARA1_FMO : Labels[langCode].INCIDENT_VALIDUSER_PARA1} {incidentNumber}.</span>
                             <span className='submitted-text'>{Labels[langCode].INCIDENT_VALIDUSER_PARA2} 6 {Labels[langCode].INCIDENT_VALIDUSER_PARA3}</span>
                            <span className='submitted-text'>{Labels[langCode].INCIDENT_VALIDUSER_PARA4}</span>
                            <span className='submitted-text'>{Labels[langCode].INCIDENT_VALIDUSER_PARA5}</span>
                            </Col>
                        </Row>    
                    </Container>
        )
    }

    const returnDuplicateUsersSummaryMessage = () =>{
        return (
            <Container fluid className="content-container">
                        <Row>
                            <Col lg={12} md={12} sm={12} xs={12} xxs={12} className="col-conetent">
                                <span className="submitted-text">
                                {isPrivate ? Labels[langCode].INCIDENT_SUBMITTED_PARA_1_FMO :  Labels[langCode].INCIDENT_SUBMITTED_PARA_1} {incidentNumber}.
                                {validUser && isFurnitureIncident ? Labels[langCode].INCIDENT_SUBMITTED_PARA_2_FURNITURE : Labels[langCode].INCIDENT_SUBMITTED_PARA_2}
                                
                                </span>
                                <span className='submitted-text-safety'>{isSafetySecurity && Labels[langCode].INCIDENT_SUBMITTED_PARA_SAFETY_SECURITY}</span>

                            </Col>
                        </Row>    
                    </Container>
        )
    }

    const summaryMessage = () =>{
        return (
            <Container fluid className="content-container">
                        <Row>
                            <Col lg={12} md={12} sm={12} xs={12} xxs={12} className="col-conetent">
                            <span className='submitted-text'>{Labels[langCode].INCIDENT_DUPLICTAE_SUBMITTED_PARA_1} '{comment}' {Labels[langCode].INCIDENT_DUPLICTAE_SUBMITTED_PARA_2} {incidentNumber} {Labels[langCode].INCIDENT_DUPLICTAE_SUBMITTED_PARA_5}.</span>
                            <span className='submitted-text'>{Labels[langCode].INCIDENT_DUPLICTAE_SUBMITTED_PARA_3}</span>
                            <span className='submitted-text'><Link to={SERVER.PLANON_URL}>{SERVER.PLANON_URL}</Link></span>
                            <p><span className='submitted-text-search'>{Labels[langCode].INCIDENT_DUPLICTAE_SUBMITTED_PARA_4}</span> <span className='submitted-text-bold'>{Labels[langCode].INCIDENTDUPLICATE5}</span> <span className='submitted-text-search'>{Labels[langCode].INCIDENTDUPLICATE6}</span></p>
                            </Col>
                        </Row>    
                    </Container>
        )
    }
 
    const summaryForInValidUserMessage = () =>{
        return (
            <Container fluid className="content-container">
                        <Row>
                        <Col lg={12} md={12} sm={12} xs={12} xxs={12} className="col-conetent">
                            <span className='submitted-text'>{isPrivate ? Labels[langCode].INCIDENT_INVALIDUSER_PARA1_FMO :  Labels[langCode].INCIDENT_INVALIDUSER_PARA1}</span>
                            <span className='submitted-text'>{Labels[langCode].INCIDENT_INVALIDUSER_PARA2}</span>
                            <span className='submitted-text'>{Labels[langCode].INCIDENT_INVALIDUSER_PARA3}</span>
                        </Col>
                        </Row>    
                    </Container>
        )
    }

    const renderSummarySection = () => {
        if (isTVMIncident) {
            return summaryForInValidUserMessage();
        }

        if (isDuplicate && isNMBSEmployee) {
            return summaryMessage();
        }

        if (!isDuplicate && isNMBSEmployee) {
            return returnDuplicateUsersSummaryMessage();
        }

        if (!isNMBSEmployee && validUser) {
            return returnValidUsersSummaryMessage();
        }

        if (!isNMBSEmployee) {
            return summaryForInValidUserMessage();
        }

        return null;
    }
    
    return(
        <>
            <Header langCode={langCode}
                handledropdown={handledropdown} isPrivate={isPrivate}/>
            <Container fluid className="main-container">
            <Row>
                <Col xl={3} lg={3} md={3} sm={0} xs={0} xxs={0}>
                    <div>
                    </div>
                </Col>
                <Col xl={6} lg={6} md={6} sm={12} xs={12} xxs={12} className="subMain-container">
                {renderSummarySection()}
                </Col>
                <Col xl={3} lg={3} md={3} sm={0} xs={0} xxs={0}>
                    <div>
                    </div>
                </Col>
                <Col  xl={12} lg={12} md={12} sm={12} xs={12} xxs={12}>
                <Container fluid className="empty-container">
                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12} xxs={12}>
                            
                        </Col>
                    </Row>    
                </Container>
                </Col>
                <Footer />
            </Row>    
            </Container>
        </>
    );
}

export default SubmittedPage;